import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingRole } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingRoleSelected.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { AgentOnboardingRole } from './agentOnboardingAnalytics';

export type UseTrackAgentOnboardingRoleSelectedParams = {
  role: AgentOnboardingRole;
};

export const useTrackAgentOnboardingRoleSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingRoleSelected = useCallback(
    (params: UseTrackAgentOnboardingRoleSelectedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingRoleSelected };
};
